import { Box } from '@mui/material'
import { Loader } from 'components/Loader'

export const LoaderPage = () => {
  return (
    <Box sx={{
      width: "100vw",
      height: "100vh",
      display: "flex",
      alignItems:"center",
      justifyContent: "center"
  }}>
      <Loader />
    </Box>
  )
}
